import { useSelector } from "react-redux";
import { useGetCurrentSessionUser } from "hooks/useGetCurrentSessionUser";

import Logo from "./Logo";
import Icon from "../../Icon";
import ThemeToggleButton from "./ThemeToggleButton";
import SubClientDropdown from "./SubClientDropdown";
import UserProfile from "./UserProfile";

import styles from "./Header.module.css";
import ToggleSidebarButton from "./ToggleSidebarButton";

export default function Header() {
  const { user } = useSelector((state: any) => state.auth);
  const currentClient = useGetCurrentSessionUser(
    "currentSelectedClient",
  ) as any;

  const clientName = currentClient?.clientName || user?.clientName;
  const userLoginUrl = localStorage.getItem("userLoginUrl");
  const showClientSwitch = user?.needToDisplayClientSwitchButton;

  return (
    <nav className={styles["header"]}>
      <div className={styles["navbar"]}>
        <div className={styles["navbar__logo__container"]}>
          <div className={styles["navbar__logo__group"]}>
            <div className={styles["logo"]}>
              <Logo />
            </div>
            <ToggleSidebarButton />
          </div>
          {showClientSwitch && (
            <SubClientDropdown
              userLoginUrl={userLoginUrl}
              userName={clientName}
            />
          )}
        </div>

        <div className={styles["nav__right"]}>
          <ThemeToggleButton />
          {/* <Icon name="bell" /> */}
          <UserProfile />
        </div>
      </div>
    </nav>
  );
}
